import { Injectable } from '@angular/core';

import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Endereco } from './endereco';

@Injectable()
export class UtilService {

  public rgMask       = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
  public data         = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public hora             = [/[0-9]/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/];
  public dataHora     = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/];
  public cnpjMask     = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public cpfMask      = [/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  public competencia  = [/[0-9]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public cep          = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  public telefone     = ['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public celular      = ['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public horaMinutoSegundo   = [/[0-9]/, /[0-9]/];
  public codigoVerificacao = [/[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/, '-', /[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/];
  public competenciaAnoMes = [/[0-9]/, /\d/, /\d/, /\d/, '/', /\d/, /\d/];
  public codigoServicoMask = [/[0-9]/, /\d/, '.', /\d/, /\d/];
  public cnaeMask          = [/[0-9]/, /\d/, /\d/, /\d/, '-', /\d/, '/', /\d/, /\d/];


  constructor () { }

  ordenarArrayData (array: Array<any>, chave: any, tipo = 'DESC') : Array<any> {
    return array.sort(function(a, b) {
      let chaveA = new Date(a[chave]),
          chaveB = new Date(b[chave]);
      if (tipo === 'ASC') {
        if(chaveA < chaveB) return -1;
        if(chaveA > chaveB) return 1;
      }
      if (tipo === 'DESC') {
        if(chaveA > chaveB) return -1;
        if(chaveA < chaveB) return 1;
      }
      return 0;
    })
  }

  /**
   *
   * GERAÇÃO DE CORES DE ACORDO COM TEXTO
   * ENVIADO POR PARAMETRO
   *
   */
  hashCode (str: string) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
       hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  intToRGB (i) {
    var c = (i & 0x00FFFFFF).toString(16).toUpperCase();
    return "00000".substring(0, 6 - c.length) + c;
  }

  getBgColor (extensao: string) {
    let hashNumber  = this.hashCode(extensao);
    let color       = this.intToRGB(hashNumber);
    let styles = {
      'background-color':  "#" + color
    };
    return styles;
  }

   /**
   * RETIRA A FORMATACAO PARA SALVAR OS
   * DADOS
   * @param campoTexto
   */
  removeFormatacao (campoTexto: string) {
    return campoTexto.replace(/(\.|\/|\-)/g,"");
  }

   /**
   * Retorna somente os numeros da string informada
   * @param campoTexto
   */
  somenteNumeros (campoTexto: string) : string {
    return campoTexto.replace(/[^0-9 ]/g, "");
  }

  /**
   * RETIRA FORMATAÇÃO DE EXIBIÇÃO DO NUMERO E RETORNA UM FLOAT
   * @param campoTexto
   */
  formatToMoeda (campoTexto: string) : number {
    return parseFloat(campoTexto.split(".").join("").replace(',', '.'));
  }

  /**
   * RETIRA A ACENTUAÇÃO DO TEXTO RECEBIDO
   * @param texto
   */
  removeAcento (texto: string) {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }

  /**
   * FUNCAO UTILIZADA PARA RETORNAR O VALOR COM MASCARA
   * AO CARREGAR OS DADOS NO INPUT AO ABRIR A TELA
   * PARA EDICAO O TEXTMASK UTILIZA A @function cpfCnpjMask
   * @param cnpjCpf
   */
  formataCnpjCpfChange (cnpjCpf: string) {
    if (cnpjCpf.length == 14) {
      return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,"\$1.\$2.\$3\/\$4\-\$5");
    } else {
      return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"\$1.\$2.\$3\-\$4");
    }
  }

  formataTelefoneChange (telefone: string) {
    if (telefone.length <= 14) {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/g,"\($1) \$2-\$3");
    } else {
      return telefone.replace(/(\d{2})(\d{5})(\d{4})/g,"\($1) \$2-\$3");
    }
  }

  cpfCnpjMask(value: any): any {

    return {
      mask: (value) => {
        if (value.length <= 14)
          return this.cpfMask;
        else
          return this.cnpjMask;
      },
      guide: false
    };
  }

  telefoneCelularMask (value: any): any | null {    
    return {
      mask: (value) => {
        if (value.length <= 14)
          return this.telefone;
        else
          return this.celular;
      },
      guide: false
    }
  }


  public keyMaskCpfCnpj (event, input) {
    let tecla = event.keyCode;
    switch (tecla) {
      case 8: {
        //console.log(input);
      }
    }
  }

  public retornaId (url: string) {
    return url.slice(-1);
  }

  public verificaAcao (route: ActivatedRoute) : boolean {
    let ret: boolean;
    route.url.subscribe(r => {
      if (r.length == 0) {
        ret = false;
      }
      else if (r.length > 0  && r[0].path == 'editar') {
        ret = true;
      }
    });
    return ret;
  }

  convertEnum (enumItem) {
		return Object.keys(enumItem).filter(k => typeof enumItem[k as any] === "number");
  }

  /**
   * VALIDA CPF OU CNPJ NA MESMA FUNÇÃO
   * @param cpfCnpj
   * @returns
   */
  public validaCpfCnpj(cpfCnpj: string): boolean {
    cpfCnpj = this.removeFormatacao(cpfCnpj);

    if(cpfCnpj.length === 11)
      return this.validaCPF(cpfCnpj);

    return this.validaCNPJ(cpfCnpj);
  }

  /**
   * Validação de CPF
   */
  public validaCPF(cpf) : boolean {
    cpf = this.removeFormatacao(cpf);

    //const message = 'Informe um CPF válido.';
    if (typeof cpf == 'undefined')
      return false;

    cpf = cpf.replace(/[^\d]+/g,'');
    if(cpf == '') return false;
    // Elimina CPFs invalidos conhecidos
    if (cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999")
        return false;
    // Valida 1o digito
    let add = 0;
    for (let i = 0; i < 9; i ++)
      add += parseInt(cpf.charAt(i)) * (10 - i);
      let rev = 11 - (add % 11);
      if (rev == 10 || rev == 11)
        rev = 0;
      if (rev != parseInt(cpf.charAt(9)))
        return false;
    // Valida 2o digito
    add = 0;
    for (let i = 0; i < 10; i ++)
      add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(10)))
      return false;
    return true;
  }

  /**
   * Validação de CNPJ
   * @param cnpj
   */
  public validaCNPJ (cnpj) : boolean {
    cnpj = this.removeFormatacao(cnpj);

    if (typeof cnpj == 'undefined')
      return false;

    //const message = 'Informe um CNPJ válido.';
    cnpj = cnpj.replace(/[^\d]+/g,'');

    if(cnpj == '') return false;

    if (cnpj.length != 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0,tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma    = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
          return false;

    return true;
  }

  public validaEnderecoRecebido(endereco: Endereco): boolean {
    if (typeof endereco.cep == 'undefined')
      return false;

    if (endereco.cep.length < 8)
      return false;

    if (typeof endereco.codigoMunicipio == 'undefined' || endereco.codigoMunicipio == '' || endereco.codigoMunicipio == null)
      return false;

    if (typeof endereco.logradouro == 'undefined' || endereco.logradouro == '' || endereco.logradouro == null)
      return false;

    if (typeof endereco.bairro == 'undefined' || endereco.bairro == '' || endereco.bairro == null)
      return false;

    if (typeof endereco.cep == 'undefined' || endereco.cep == '' || endereco.cep == null)
      return false;

    if (typeof endereco.localidade == 'undefined' || endereco.localidade == '' || endereco.localidade == null)
      return false;

    if (typeof endereco.uf == 'undefined' || endereco.uf == '' || endereco.uf == null)
      return false;

    if (typeof endereco.numero == 'undefined' || endereco.numero == '' || endereco.numero == null)
      return false;

    return true;
  }


}